import { render, staticRenderFns } from "./ServerArea.vue?vue&type=template&id=58d84e6d&scoped=true"
import script from "./ServerArea.vue?vue&type=script&lang=js"
export * from "./ServerArea.vue?vue&type=script&lang=js"
import style0 from "./ServerArea.vue?vue&type=style&index=0&id=58d84e6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d84e6d",
  null
  
)

export default component.exports